import { MprcRequestErrorDialog, MprcRequestIndicator } from 'components';
import { MprcRibbonGenericCard, MprcRibbonList, MprcRibbonListContainer, MprcRibbonListHandle } from "components/MprcRibbonList";
import { CarouselCardRenderMode } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CardDtoToCardRibbon } from 'views/general/Cards/CardDtoToCardRibbon';

////////////////////////////////////////////////////////////////////////////////

export const MATERIAL_LIST_CONTAINER_ID = 'viewMaterialListContent';

type ListType = {
    id: string;
    title: string;
};

interface IProps {
    classroomId: string;
}

export const MaterialListRibbons = ({ classroomId }: IProps) => {
    const api = useCoreApi();
    const { t } = useTranslation("lms");

    const [expandIndex, setExpandIndex] = useState<number | undefined>(undefined);
    const [viewError, setViewError] = useState<any>(null);
    const [lists, setLists] = useState<ListType[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const listRibbonRefs = useRef<{ [key: string]: MprcRibbonListHandle | null; }>({});

    ///
    const loadMaterialLists = async () => {
        try {
            var ml = await api.v1.enrollment.getMaterialLists({ classroomId });
            setLists(ml.data.map(item => ({ id: item.materialListId, title: item.name }) as ListType));
        }
        catch {
        }
        finally {
            setLoading(false);
        }
    };

    ///
    const handleExpand = (index: number) => () => {
        setExpandIndex(index == expandIndex ? undefined : index);
    };

    ///
    const handleGetData = (id: string, expanded: boolean) => {
        const list = lists.find(p => p.id == id);

        return new Promise<React.ReactNode[]>((resolve, reject) => {
            if (list == null)
                reject('Invalid List Id');
            else {
                api.v1.enrollment.getMaterialListCards(
                    {
                        classroomId,
                        materialListId: id,
                        pageNumber: 1,
                        pageSize: expanded ? 9999 : 20
                    }
                ).then((response) => {
                    resolve(
                        CardDtoToCardRibbon(
                            response.data.items,
                            CarouselCardRenderMode.Default,
                            {
                                onCarouselReload: () => listRibbonRefs.current[id]?.reset(),
                                saveState: { source: "materialList" },
                            }
                        )
                    );
                }).catch(e => reject(e));
            }
        });
    };

    useEffect(() => {
        loadMaterialLists();
    }, []);

    ///
    return (
        <>
            <MprcRequestErrorDialog error={viewError} onClose={() => setViewError(null)} />

            <MprcRequestIndicator type="request" visible={loading} />

            {
                lists.map((item, index) => (

                    <MprcRibbonListContainer containerId={MATERIAL_LIST_CONTAINER_ID}>
                        {
                            (maxWidth, gap, margin) => {
                                return (
                                    <div id="abc">
                                        <MprcRibbonList
                                            key={index}
                                            id={item.id}
                                            index={index}
                                            gapWidth={gap}
                                            slideWidth={maxWidth + gap}
                                            title={item.title.toUpperCase()}
                                            maxItems={20}
                                            ref={ref => { if (ref != null) listRibbonRefs.current[item.id] = ref; }}
                                            ribbonCardLoadMore={
                                                MprcRibbonGenericCard({
                                                    message: t("Card.ShowMoreCards", { ns: "core" }),
                                                    marginWidth: margin,
                                                    onClick: () => setExpandIndex(index)
                                                })
                                            }
                                            expanded={expandIndex === index}
                                            visible={expandIndex == undefined || expandIndex === index}
                                            onExpandClick={handleExpand(index)}
                                            onGetCards={(id, expanded) => handleGetData(id, expanded)}
                                        />
                                    </div>
                                );
                            }
                        }
                    </MprcRibbonListContainer>
                ))
            }
        </>
    );
};
